'use client';

import type {
  SearchProductService,
  SearchProductsServiceResponse,
} from '@musinsa/services-curator';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { curatorQueries } from '../../query-factory';

interface UseSearchProductsInfiniteQueryProps {
  keyword: string;
  size?: number;
}

export const useSearchProductsInfiniteQuery = ({
  keyword,
  size = 20,
}: UseSearchProductsInfiniteQueryProps) => {
  const query = useInfiniteQuery({
    ...curatorQueries.products.search({ keyword, size }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: SearchProductsServiceResponse) =>
      lastPage.pagination.hasNextPage ? lastPage.pagination.nextPage : undefined,
    enabled: keyword.length > 0, // 키워드가 있을 때만 쿼리 실행
  } as const);

  const flattenedData: SearchProductService[] = useMemo(
    () => query.data?.pages.flatMap((page) => page.list) ?? [],
    [query.data],
  );

  const total = useMemo(() => query.data?.pages[0]?.total ?? 0, [query.data]);

  return {
    ...query,
    products: flattenedData,
    total,
  };
};
